namespace GeniuzPOS.Administration {
    export class CsParaColumns {
        static columnsKey = 'Administration.CsPara';
    }
}
